
function initAgeVerification() {

    if (Cookies.get('AgeVarified') === 'true') {
        document.body.classList.add('varified-age');
        return;
    }

    const productGrid = document.getElementById('ProductGridContainer');
    if (!productGrid) return;

    productGrid.addEventListener('click', function (e) {
        const trigger = e.target.closest('.popup-age-trigger');
        if (trigger) {
            const parent = trigger.parentNode;
            parent.classList.add('active');
        }
    });

    productGrid.addEventListener('click', function (e) {
        const confirmBtn = e.target.closest('.age-confirmation__button');
        if (confirmBtn) {
            Cookies.set('AgeVarified', 'true', { expires: 1 });
            document.body.classList.add('varified-age');
        }
    });
}

initAgeVerification();
